import { theme } from '@garnish/constants';

export const SIDE_PADDING = theme.spacing['10'];

export const BUTTON_HEIGHT = 72;

export const LINE_ITEM_CONTAINER_WIDTH = 260;
export const ADDED_TO_BAG_CHECK_SIZE = 40;

export const LARGE_PRODUCT_SIZE_THRESHOLD = 6;

export const DYNAMIC_BAG_LABEL_TIMER = 1000;

const ANIMATION_START_DELAY = 700;

export const ANIMATION_DELAYS = {
  ITEM_CONFIRMATION: ANIMATION_START_DELAY,
  UPSELL_OPTIONS: ANIMATION_START_DELAY + 600,
};
